import _find from 'lodash/find'

class InstallationGuideController {
  constructor (Localization, VehicleService, I18n) {
    'ngInject'
    this.appConfig = Localization.getLocalizedAppConfig()
    this.VehicleService = VehicleService
    this.I18n = I18n
    this.loaded = this.init()
  }

  init () {
    return this.VehicleService.getCurrentSelectedVehicle()
    .then((v) => {
      this.model = v ? v.huType : null
      this.downloadLinks = _find(this.appConfig.rlinkModels, ['huType', this.model]).toolbox
      return v
    })
  }
}

export default InstallationGuideController



// WEBPACK FOOTER //
// ./src/app/pages/installation/installation-guide/installation-guide.controller.js